import Typography from '@mui/material/Typography';

export default function FormWithDescription({
  title,
  description,
  children,
  marginTop,
  isWide,
}) {
  return (
    <div className={marginTop ? `row mt-5` : 'row'}>
      <div className={`col-12 ${isWide ? 'col-md-6' : 'col-sm-4'}`}>
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" className="mb-3 text-justify">
          {description}
        </Typography>
      </div>
      <div
        className={`col-12 ${
          isWide ? 'col-md-6' : 'col-sm-8'
        } d-flex justify-content-center align-items-center`}
      >
        <div className="flex-grow-1">{children}</div>
      </div>
    </div>
  );
}
